import { AppState } from '../../interfaces';
import { connect } from 'react-redux';
import PageFreeProducts from './FreeProducts';
import {
  getFreeProducts,
  addToOrder,
  removeFromOrder,
  getAddresses,
} from '../../actions/freeProducts';
import { getPropertyDetails } from '../../actions/user';
import { setMeta } from '../../actions';

const mapStateToProps = (state: AppState) => ({
  page: state.freeProductsReducer,
  listLocation: state.listLocationReducer,
  user: state.userReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getFreeProducts: (slug) => dispatch(getFreeProducts(slug)),
  getAddresses: (postcode) => dispatch(getAddresses(postcode)),
  addToOrder: (id) => dispatch(addToOrder(id)),
  removeFromOrder: (id) => dispatch(removeFromOrder(id)),
  getPropertyDetails: (id) => dispatch(getPropertyDetails(id)),
  setMeta: (propertyId) => dispatch(setMeta(propertyId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageFreeProducts);
